import { Typography } from '@/shared/ui';

export const EmptyState = () => {
  return (
    <div className="flex h-full items-center justify-center p-5 pb-20">
      <Typography variant="14-r" color="text-base-100">
        Nothing was&nbsp;found&nbsp;for&nbsp;your&nbsp;search
      </Typography>
    </div>
  );
};
